<template>
  <div class="index" @click="h5show = false">
    <!-- <div class="imgcenter">
      <img src="../../static/bg4.jpg" />
    </div> -->
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("awardstitle") }}</span>
      </div>

      <div class="small-title">{{ $t("awardstitle1") }}</div>
      <div class="small-title">
        {{ $t("awardstitle2") }}
      </div>
      <div class="small-title">{{ $t("awardstitle3") }}</div>
      <div class="small-title">{{ $t("awardstitle4") }}</div>
      <div class="small-title">{{ $t("awardstitle5") }}</div>


      <div class="bottom_span"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.bottom_span {
  padding-top: 80px;
}

.imgcenter {
  width: 100%;
  padding: 0px 0 20px 0;
}

.imgcenter img {
  width: 100%;
  height: 280px;
}

.top {
  /*position: fixed;*/
  top: 150px;
  left: 0;
  background: #fff;
  height: 70px;
  box-sizing: border-box;
  z-index: 99;
  width: 100%;
  border-top: 10px solid #0a9a7a;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.navbg {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

.top-bg {
  background-image: url("https://img0.baidu.com/it/u=2363835659,3802656139&fm=253&fmt=auto&app=138&f=JPEG?w=1180&h=492");
  background-size: 100% auto;
  height: 150px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
}

.bannerbg {
  width: 100%;
  height: 150px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  background: rgba(255, 255, 255, 0.5);
  justify-content: space-between;
}

.aboutcom {
  padding-right: 150px;
  flex: 1;
}

.aboutcomtitle1 {
  font-size: 25px;
  color: #000;
  padding-top: 20px;
}

.aboutcomtitle2 {
  font-size: 18px;
  color: #413939ad;
}

.language {
  display: flex;
}

.language1 {
  padding-top: 10px;
}

.language2 {
  padding: 10px 10px 0 10px;
}

.nav {
  color: #0a9a7a;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  width: 1200px;
  display: flex;
  justify-content: space-between;
}

.nav span {
  padding: 0 15px;
  box-sizing: border-box;
  line-height: 50px;
  display: inline-block;
  cursor: pointer;
  font-size: 16px;
}

.nav span:hover,
.nav .active {
  color: #04551f;
  font-weight: 500;
  transition: 0.3s all;
  border-bottom: 2px solid #0a9a7a;
}

.h5-menu {
  text-align: right;
  padding: 15px;
  box-sizing: border-box;
  display: none;
  position: relative;
}

.el-icon-menu {
  font-size: 24px;
  color: #0a9a7a;
}

@media screen and (max-width: 768px) {
  .bannerbg img {
    height: 70px;
  }

  .bannerbg {
    display: block;
  }

  .language {
    position: relative;
    left: 20px;
    top: 20px;
  }

  .aboutcom {
    display: none;
    padding-right: 10px;
  }

  .h5-menu {
    display: block;
  }

  .h5-nav {
    position: absolute;
    background: #fff;
    top: 100%;
    border: 1px solid #ddd;
    box-shadow: 3px 3px 4px #ddd;
    right: 10px;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
  }

  .h5-title {
    text-align: right;
  }

  .h5-nav p {
    height: 36px;
    display: flex;
    border-bottom: 1px dashed #eee;
    align-items: center;
  }

  .h5-nav p.active {
    color: #04551f;
    font-weight: 600;
  }

  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .navbg {
    display: none;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/awards.vue